import { useEffect } from "react";
import { ADSENSE_CLIENT } from "@/lib/config";
import { COOKIE_CONSENT_KEY } from "@/lib/legal";

export const readCookieConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(COOKIE_CONSENT_KEY) || "null")?.value || null;
  } catch {
    return null;
  }
};

// Personalised ads only with full consent; otherwise Google serves non-personalised ads.
export const applyAdsPersonalization = (consent) => {
  window.adsbygoogle = window.adsbygoogle || [];
  window.adsbygoogle.requestNonPersonalizedAds = consent === "all" ? 0 : 1;
};

export const AdSenseLoader = () => {
  useEffect(() => {
    if (!ADSENSE_CLIENT || document.getElementById("adsense-script")) return;
    if (window.location.pathname.startsWith("/admin")) return;
    applyAdsPersonalization(readCookieConsent());
    const script = document.createElement("script");
    script.id = "adsense-script";
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
    script.setAttribute("data-testid", "adsense-script");
    document.head.appendChild(script);
  }, []);
  return null;
};
